import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clear } from './ProjectIcons';
import { filterClasses } from './tailwindClassnames';

type SearchChipProps = {
    value: string;
    onClear: () => void;
};

const SearchChip = ({ value, onClear }: SearchChipProps) => {
    const { t } = useTranslation();
    return (
        <span className="flex items-center gap-2 h-[38px] mb-2 border border-gray-lines rounded px-2 py-1">
            <span className="text-base font-normal text-secondary-text">{t("Contains")}</span>
            <span className={`${filterClasses.tag} !mt-0 text-sm font-normal text-off-black`}>&ldquo;{value}&rdquo;</span>
            <button type="button" className="cursor-pointer text-dark-green" aria-label={t("Clear search filter")} onClick={onClear}><Clear /></button>
        </span>
    );
};

export default SearchChip;
